export function goBack() {
    console.log('NATIVE EVENT: GO BACK');
    const data = {
        event: 'back'
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function shopNow() {
    console.log('NATIVE EVENT: SHOP NOW');
    const data = {
        event: 'Shop'
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}
export function loadCard() {
    console.log('NATIVE EVENT: Laod Card');
    const data = {
        active: true,
        event: 'navigate',
        location: 'RechargeCard'
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}
export function activateCard() {
    console.log('NATIVE EVENT: Activate Card');
    const data = {
        active: true,
        event: 'navigate',
        location: 'screenCardOnBoardingIntroAnim'
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}
export function offersBrands() {
    console.log('NATIVE EVENT: OFFERS BRANDS');
    const data = {
        active: true,
        event: 'navigate',
        location: 'Dashboard',
        data: {
            screen: 'Brands',
            params: { scrollToSection: '' }
            // params: { scrollToSection: 'Bitcoin Rewards Bonanza' }
        }
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function goToBrandCategory(category) {
    console.log('NATIVE EVENT: BRAND CATEGORY', category);
    const data = {
        active: true,
        event: 'navigate',
        location: 'Dashboard',
        data: {
            screen: 'Brands',
            params: { scrollToSection: category }
        }
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function purchaseCard(code) {
    console.log('NATIVE EVENT: BUY CARD');
    if (code && window?.navigator?.clipboard) {
        window.navigator.clipboard.writeText(code);
    }
    const data = {
        active: true,
        /* data: {
            code: code
        }, */
        event: 'navigate',
        location: 'screenCardCompare'
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function upgradeCard(code) {
    console.log('NATIVE EVENT: BUY CARD');
    if (code && window?.navigator?.clipboard) {
        window.navigator.clipboard.writeText(code);
    }
    const data = {
        active: true,
        /* data: {
            code: code
        }, */
        event: 'navigate',
        location: 'screenUpgradeCardInfo'
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function shareWithFriends(message) {
    const msg = `${message} `;
    console.log('NATIVE EVENT: SHARE WITH FRIENDS', message);
    const data = {
        event: 'share',
        message: msg
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function shareReferral(code, link) {
    console.log('NATIVE EVENT: SHARE REFERRAL', code, link);
    const msg = `Hi 😃. Hey! Join me in the Bitcoin Premier League and win exciting rewards in Bitcoin & Gold every time you shop. ${link}`
    // const msg = `Heyy! 😃 Use my personal GoSats Valentines Week invite to earn Flat 10% rewards in Gold or Bitcoin on brands like Swiggy, Zomato, Myntra, Nykaa and many more with the GoSats Elite card. Offer ends on 14th February, end of day. Thank me later!\nGet now: https://gosats.onelink.me/O1LB/pj1bifwh`
    console.log('NATIVE EVENT: SHARE WITH FRIENDS', msg);
    const data = {
        event: 'share',
        message: msg
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function goHistory() {
    console.log('NATIVE EVENT: HISTORY');
    const data = {
        event: "TabNavigate",
        location: "History"
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function goMerchant(id) {
    console.log('NATIVE EVENT: MERCHANT PAGE');
    const data = {
        event: "navigate",
        location: "BrandDetail",
        data: {
            id: id
        }
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function goHome() {
    console.log('NATIVE EVENT: HOME');
    const data = {
        event: "TabNavigate",
        location: "Dashboard"
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function lumpsumScreen(amount = 500) {
    const data = {
        active: true,
        event: 'navigate',
        location: 'screenGoldSIPInvest',
        data: {
            oneTimeInvestment: true,
            amount: amount
        },
        tracking: {
            event: 'InApp Campaign Page',
            properties: {
                amount: amount,
                name: 'Gold SIP Investment'
            }
        }
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function vkyc() {
    console.log('NATIVE EVENT: VKYC');
    const data = {
        event: 'navigate',
        location: 'screenVKYCIntro'
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}